import React, { useState, useEffect } from "react";
import image1 from "../assets/bgs/wtf.webp";
import image2 from "../assets/bgs/no.webp";
import image3 from "../assets/bgs/sffs.webp";
import image4 from "../assets/bgs/col.webp";
import image5 from "../assets/bgs/amenra.webp";

const images = [image1, image2, image3, image4, image5];

const RandomImageBackground = ({ blur = 5, opacity = 0.3 }) => {
  const [randomImage, setRandomImage] = useState(null);

  useEffect(() => {
    // Only set the random image once when the component mounts
    setRandomImage(images[Math.floor(Math.random() * images.length)]);
  }, []); // Empty dependency array ensures this runs only once

  if (!randomImage) {
    // Render a placeholder or loading state while the image is being set
    return <div className="relative w-full h-screen">Loading...</div>;
  }

  return (
    <div
      className="relative w-full h-screen"
      style={{
        backgroundImage: `url(${randomImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        filter: `blur(${blur}px)`,
        opacity: `${opacity}`,
      }}
    ></div>
  );
};

export default RandomImageBackground;
